<table class="table table-borderless table-striped table-hover align-middle punchout-audit-table">
  <colgroup>
    <col style="width: 130px" />
    <col />
    <col style="width: 110px" />
    <col />
    <col />
    <col />
    <col style="width: 120px" />
  </colgroup>
  <thead>
    <tr>
      <th>{{ 'TIMESTAMP' | translate }}</th>
      <th>{{ 'PUNCHOUT_CONFIG' | translate }}</th>
      <th>{{ 'STATUS' | translate }}</th>
      <th>{{ 'PUNCHOUT_PAYLOAD_ID' | translate }}</th>
      <th>{{ 'PUNCHOUT_EDI_MESSAGE' | translate }}</th>
      <th>{{ 'ERROR' | translate }}</th>
      <th class="text-end"></th>
    </tr>
  </thead>
  <tbody>
    @for (entry of data; track entry.id) {
      <tr>
        <td>{{ entry.timestamp | date: 'yyyy-MM-dd HH:mm' }}</td>
        <td>
          {{ entry.configLabel }}
          @if (entry.configMissing) {
            <i
              class="fa-solid fa-triangle-exclamation text-warning ms-1"
              [title]="'PUNCHOUT_CONFIG_DELETED' | translate"
            ></i>
          }
        </td>
        <td>
          <span class="badge" [ngClass]="statusClass(entry.status)">{{ entry.status || 'UNKNOWN' | translate }}</span>
        </td>
        <td>
          <code class="punchout-audit-id">{{ entry.payloadId || '-' }}</code>
        </td>
        <td>
          @if (entry.ediMessageId) {
            @if (ediEnabled) {
              <a [routerLink]="['/admin/edi/orders', entry.ediMessageId]" class="punchout-audit-id">
                {{ entry.ediMessageId }}
              </a>
            } @else {
              <code class="punchout-audit-id">{{ entry.ediMessageId }}</code>
            }
          } @else {
            -
          }
        </td>
        <td class="text-danger punchout-audit-error">
          {{ entry.errorMessage || '' }}
        </td>
        <td class="text-end">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            [disabled]="loadingId === entry.id"
            (click)="inspect(entry)"
          >
            @if (loadingId === entry.id) {
              <i class="fa fa-spinner fa-spin me-1"></i>
            } @else {
              <i class="fa-solid fa-magnifying-glass me-1"></i>
            }
            <span>{{ 'PUNCHOUT_INSPECT' | translate }}</span>
          </button>
        </td>
      </tr>
    }
  </tbody>
</table>
